// utils/showLogoutPopup.ts
import i18n from "../i18n";

export function showLogoutPopup(message = i18n.t("You were logged out")) {
  // Create wrapper
  const popup = document.createElement("div");
  popup.textContent = message;

  // Basic styling – tweak as you like
  Object.assign(popup.style, {
    position: "fixed",
    top: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "12px 20px",
    background: "#d32f2f", // red background
    color: "#fff",
    fontFamily: "sans-serif",
    fontSize: "14px",
    borderRadius: "6px",
    boxShadow: "0 2px 6px rgba(0,0,0,.25)",
    zIndex: "9999",
    opacity: "0",
    transition: "opacity 0.25s ease",
  });

  document.body.appendChild(popup);

  // Fade in
  requestAnimationFrame(() => (popup.style.opacity = "1"));

  // Remove after 1.5 s
  setTimeout(() => {
    popup.style.opacity = "0";
    popup.addEventListener("transitionend", () => popup.remove());
  }, 1500);
}
